import PropTypes from 'prop-types';
import CarouselSlide from './carouselSlide';
import {ButtonFlatLink} from 'ui';
import {Container, CarouselTitle, Slides} from './styles';

const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToScroll: 2,
  arrows: true,
  variableWidth: true,
};

const CarouselBlock = ({carouselData}) => (
  <Container className="productsCarousel">
    <CarouselTitle>Dans la recette</CarouselTitle>
    <Slides
      className={carouselData.length === 1 ? 'oneSlide' : ''}
      {...{
        ...settings,
        slidesToShow: carouselData.length > 1 ? 2 : 1,
      }}>
      {carouselData.map((slideData, id) => (
        // eslint-disable-next-line react/no-array-index-key
        <CarouselSlide key={id} slideData={slideData} />
      ))}
    </Slides>
    <ButtonFlatLink
      href="https://www.relaisdor.fr/trouver-un-concessionnaire/"
      target="_blank"
      style={{fontSize: 16}}>
      Commander ces produits
    </ButtonFlatLink>
  </Container>
);

CarouselBlock.propTypes = {
  carouselData: PropTypes.array,
};

export default CarouselBlock;
